export type TProduto = {
    id: number,
    nome: string,
}

export const defValueProduto: TProduto = 
{
  id: 0,
  nome: ''
}